// order_time
export enum RechargeHistoryType {
  SystemReviewOne = '0', // 系统审核中
  SystemReviewTwo = '1', // 系统审核中
  RechargingOne = '2', // 充值中
  RechargingTwo = '3', // 充值中
  AccountCredited = '4', // 已到账
  // RefundProcessing = '5', // 退款中
  // Refunded = '6', // 已退款
}

export interface IReferenceID {
  readonly reference_id: string; // 可用余额
  readonly receive_bank_account: string;
}

// 目前字段未确定
export interface IRechargeHistoryItem {
  readonly total: string; // 数据总数
  readonly size: string; // 每页数量
  readonly list: ReadonlyArray<IRechargeHistoryList>;
}

export interface IRechargeHistoryList {
  readonly receive_bank_openname: string; // 汇款户名
  readonly receive_bank_name: string; // 汇款银行
  readonly receive_bank_account: string; // 汇款账号
  readonly amt: string; // 汇款金额 (¥)
  readonly provide_time: string; // 汇款到账时间
  readonly order_state: RechargeHistoryType; // 状态
}

export enum MidasAccountStatus {
  NORMAL = 1, // 正常
  OVERDUE = 2, // 欠费
  UNANTHORIZED = 3, // 企业本认证
}

export interface IMidasAccountInfo {
  readonly account: string;
  readonly account_status: MidasAccountStatus;
  readonly create_time: string;

  readonly alarm_balance: string | null;
  readonly alarm_receiver: string | null;
}
